import { useSelector } from 'react-redux';
import { RadioField } from '@pinwheel/origami';
import React, { useMemo } from 'react';
import useFullSwitchAndMoreContext from './hooks/useFullSwitchAndMoreContext';
import { useSetAmountSelection } from '../../../hooks/useSetAmountSelection';
import { useGetLocalizedString } from '../../../hooks/useGetLocalizedString';
import { selectLinkParams } from '../../../state/slices/slice-link-params';
import { selectLoadedPlatform } from '../../../state/slices/slice-link-api';
import { getAmountSelectionType } from '../../../screens/AmountSelection';
function RemainderRadioButton() {
    var selectionType = useFullSwitchAndMoreContext().selectionType;
    var setAmountSelection = useSetAmountSelection();
    var getLocalizedString = useGetLocalizedString();
    var linkParams = useSelector(selectLinkParams);
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var amountSelectionType = useMemo(function () {
        return getAmountSelectionType(linkParams, loadedPlatform);
    }, [linkParams, loadedPlatform]);
    var eventId = useMemo(function () {
        return amountSelectionType === 'FullSwitchAndMore'
            ? 'FullSwitchAndMore-partialPaycheck'
            : "".concat(amountSelectionType, ".entirePaycheck");
    }, [amountSelectionType]);
    var dataTestId = useMemo(function () {
        return amountSelectionType === 'FullSwitchAndMore'
            ? 'Radio-partialPaycheck'
            : // In cases where full switch is not supported, remainder is considered the "entire paycheck"
                'Radio-entirePaycheck';
    }, [amountSelectionType]);
    return (React.createElement(RadioField, { "data-testid": dataTestId, value: "entirePaycheck", eventId: eventId, checked: selectionType === 'remainder', label: getLocalizedString('REMAINDER_FOR_LEGACY_SWITCH'), onChange: function () {
            return setAmountSelection({
                action: 'partial_switch',
                allocation: {
                    type: 'remainder',
                },
            });
        } }));
}
export default RemainderRadioButton;
